export default __webpack_public_path__ + "static/media/terms-of-use.856f0a33.md";